import { render, staticRenderFns } from "./HubContactsList.vue?vue&type=template&id=895105ea&"
import script from "./HubContactsList.vue?vue&type=script&lang=js&"
export * from "./HubContactsList.vue?vue&type=script&lang=js&"
import style0 from "./HubContactsList.vue?vue&type=style&index=0&id=895105ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports